<template>
  <el-select
    v-bind="custom"
    :class="classNames"
    :disabled="disabled"
    :loading="isLoadingRef"
    :multiple="multiple"
    :placeholder="$t('placeholder.select')"
    :remote-method="updateCategoryListByKeyword"
    :value="value"
    filterable
    remote
    @change="handleUpdateSelectedCategories"
  >
    <el-option
      v-for="item in categoriesRef"
      :key="item.slug"
      :label="item.slug"
      :value="item.slug"
    />
  </el-select>
</template>

<script>
import { createComponent, ref, computed, onMounted } from '@vue/composition-api'

import VaderService from '../../api/vader'
import VaderUtils from '../../utils/vader'

const CategorySelector = createComponent({
  props: {
    value: {
      type: [Array, String],
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    custom: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const firstLoad = ref(true)

    const isLoadingRef = ref(false)
    const classNames = computed(() => ({
      'w-100': props.fullWidth,
    }))

    let options = []
    const categoriesRef = ref([])
    const updateCategoryListByKeyword = (value) => {
      const lowercasedValue = value.toLowerCase()
      categoriesRef.value = Object.keys(options).reduce((acc, key) => {
        if (key.includes(lowercasedValue)) {
          acc[key] = options[key]
        }
        return acc
      }, {})
    }
    const handleUpdateSelectedCategories = (selectedCategories) => {
      if (firstLoad.value) {
        // fix the el-select always emit empty string / array on mount
        firstLoad.value = false
        return
      }

      emit('input', selectedCategories)
    }

    const getCategoryData = async () => {
      isLoadingRef.value = true
      try {
        const { data: { data: categoriesData } } = await VaderService.getCategories()
        options = VaderUtils.flattenCategoryTree(categoriesData)
        categoriesRef.value = options
      } catch (error) {
        console.error(error);
      } finally {
        isLoadingRef.value = false
      }
    }

    onMounted(() => {
      handleUpdateSelectedCategories([])
      getCategoryData()
    })

    return {
      isLoadingRef,
      classNames,

      categoriesRef,

      updateCategoryListByKeyword,
      handleUpdateSelectedCategories,
    }
  },
})

export default CategorySelector
</script>
